import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const costs = ['Nights lost searching for combinations that actually work and flow together', 'Classes that feel repetitive because you keep falling back on the same exercises', 'Visible improvisation that quietly chips away at your confidence as a teacher', 'No technical variety across weeks—and students who plateau without knowing why', 'Weekends spent planning instead of resting, recovering, or living your life', 'Recitals that feel chaotic because there was no system to organize them', 'No simple way to track student progress or show parents what their children are achieving'];
export function PainPoints() {
  return <section className="bg-ballet-canvas px-4 py-20 sm:py-28" data-id="element-170" data-mp="1szg288ddkspf">
      <div className="mx-auto max-w-3xl" data-id="element-171" data-mp="3iduq6qgkkbjv">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-172" data-mp="3ie4febtsieoi">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-ballet-rose" data-id="element-173" data-mp="1u0ixh14m9otg">
            A familiar Sunday night
          </p>
          <h2 className="mt-3 font-display text-5xl font-semibold text-ballet-ink" data-id="element-174" data-mp="27v33mhnlehtl">
            Does this sound familiar?
          </h2>
          <div className="mt-7 rounded-2xl border border-ballet-line bg-white p-6 text-left text-base leading-7 text-ballet-muted shadow-card sm:p-8" data-id="element-175" data-mp="1g1astspopohv">
            <p data-id="element-176" data-mp="1b4kcr5dvqswg">Sunday night. 10pm. You have a ballet class tomorrow morning.</p>
            <p className="mt-4" data-id="element-177" data-mp="1p3ab0ocfqyme">
              And you are still sitting there—searching for combinations, trying
              to build a barre sequence that actually flows, wondering if your
              center work makes sense for this group&apos;s level.
            </p>
            <p className="mt-4" data-id="element-178" data-mp="2vjcmbapiepgi">
              <strong className="font-semibold text-ballet-ink" data-id="element-179" data-mp="2vi1lnjrd1xtm">
                Not because you don&apos;t know ballet. You know ballet.
              </strong>
            </p>
            <p className="mt-4" data-id="element-180" data-mp="1y36ukvu3d190">
              Because nobody ever gave you a complete, ready-to-teach library.
              You have been building every single class from scratch. The time
              you should be resting, you spend planning—and walking into the
              studio wishing you had been better prepared.
            </p>
          </div>
        </motion.div>

        <div className="mt-14" data-id="element-181" data-mp="1efr1r1p6gihm">
          <h3 className="text-center text-xl font-semibold text-ballet-ink" data-id="element-182" data-mp="1eh218pblb42x">
            The real cost of not having the right resource:
          </h3>
          <ul className="mt-7 space-y-3" data-id="element-183" data-mp="1o5sdqv49aag6">
            {costs.map((cost, index) => <motion.li key={cost} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-3 rounded-xl border border-ballet-pink/45 bg-ballet-blush/55 px-5 py-4 text-sm leading-6 text-ballet-muted" data-id="element-184" data-mp="qqo96yt0958c" data-mpi={index}>
                <XIcon size={17} className="mt-0.5 shrink-0 text-ballet-rose" aria-hidden="true" data-id="element-185" data-mp="a8ti1cmupvjk" />
                {cost}
              </motion.li>)}
          </ul>
          <div className="mt-12 border-t border-ballet-gold/55 pt-8 text-center" data-id="element-186" data-mp="3ro0dgzo2snsq">
            <p className="font-display text-3xl font-semibold text-ballet-ink" data-id="element-187" data-mp="3modxwjkryvgr">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="mt-3 text-lg font-semibold text-ballet-rose" data-id="element-188" data-mp="3doiig2k6seax">
              Plan an entire year of ballet classes today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}